import { breakpoints } from '@gassan-ui'
import styled, { css } from 'styled-components'
import { ColorProps, color } from 'styled-system'

const item = css`
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-family: ${(p) => p.theme.fonts.heading};
  outline: 0;

  @media screen and (min-width: ${breakpoints.small}) {
    width: 2.5rem;
    height: 2.5rem;
    font-size: 1.5rem;
    margin: auto 6px;
  }
`

export const Arrow = styled.button`
  ${item};

  &:active {
    svg {
      transform: scale(0.95);
    }
  }

  &:disabled {
    color: ${(p) => p.theme.colors.shades[500]};
    cursor: initial;
  }
`

export const Button = styled.button<ColorProps & { isActive?: boolean }>`
  ${item};
  ${color};
  transition: color 0.2s ease-in-out;
  position: relative;

  @media screen and (min-width: ${breakpoints.small}) {
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 50%;
      background: currentColor;
      height: 2px;
      opacity: ${(p) => (p.isActive ? 1 : 0)};
      transition: all 0.2s ease;
    }
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      &:after {
        opacity: 1;
      }
    }
  }
`
export const Dots = styled.span`
  ${item};
`
